/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-23 14:26:19
 * @LastEditors: linxi
 * @LastEditTime: 2023-02-21 14:41:43
 */
import {
  getTenantCategoryName,
  getTeantTypeName,
  getPlatformTypeName,
} from '../../../models/tenant'
import { Button, Space, TableColumnType, Tooltip } from 'antd'
import React, { ReactElement } from 'react'
import styles from '../monitoringTab.module.css'

export const Columns = (
  onClick: (t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '5rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },

    {
      title: '机构名称',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: function tenantName(_, t) {
        return t?.name ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title={t.name}>
              <div className={styles.tableText}>{t.name}</div>
            </Tooltip>
            {t.insuranceStatus ? <div className={styles.textName}>保</div> : ''}
          </div>
        ) : (
          '-'
        )
      },
    },
    {
      title: '机构类别',
      key: 'tenantCategory',
      dataIndex: 'tenantCategory',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => getTenantCategoryName(t.tenantCategory),
    },
    {
      title: '机构类型',
      key: 'tenantType',
      dataIndex: 'tenantType',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      // render: (_, t) => getTeantTypeName(t.tenantType)
    },

    {
      title: '所属平台',
      dataIndex: 'platformType',
      key: 'platformType',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => getPlatformTypeName(t.platformType),
    },
    {
      title: '所在区域',
      dataIndex: 'address',
      key: 'address',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      // render: function address(_, t) {
      //   return t?.address
      //     ?
      //     <Tooltip
      //       title={t.address}
      //     >
      //       <div className={styles.tableText}>{t.address}</div>
      //     </Tooltip>
      //     : '-'
      // },
    },

    {
      title: '近14天门诊次数',
      dataIndex: 'outpatientNumber',
      key: 'outpatientNumber',
      align: 'center',
      width: '10rem',
      // ellipsis: true,
      // render: function tenantCategory(_, t) {
      //   return t.price.toFixed(2)
      // },
      sorter: true,
    },
    {
      title: '近14天结算笔数',
      dataIndex: 'settlementNumber',
      key: 'settlementNumber',
      align: 'center',
      width: '10rem',
      sorter: true,
    },
  ]
}
export const overviewColumns = (): TableColumnType<any>[] => {
  return [
    {
      title: '区域',
      dataIndex: 'region',
      key: 'region',
      align: 'center',
      width: '100px',
    },

    {
      title: '机构总数',
      dataIndex: 'tenantNumSum',
      key: 'tenantNumSum',
      align: 'center',
      width: '100px',
    },
    {
      title: '活跃机构数',
      key: 'activeTenantNum',
      dataIndex: 'activeTenantNum',
      align: 'center',
      width: '110px',
    },
    {
      title: '医保机构数',
      key: 'insuranceTenantNum',
      dataIndex: 'insuranceTenantNum',
      align: 'center',
      width: '110px',
    },
    {
      title: '非医保机构数',
      dataIndex: 'tenantNum',
      key: 'tenantNum',
      align: 'center',
      width: '120px',
    },
    {
      title: '聚网机构数',
      dataIndex: 'jwTenantNum',
      key: 'jwTenantNum',
      align: 'center',
      width: '120px',
    },
    {
      title: '好医点机构数',
      dataIndex: 'hyTenantNum',
      key: 'hyTenantNum',
      align: 'center',
      width: '120px',
    },
  ]
}
